<div class="parsys" *ngIf="displaySuccessMessage || displaySuccessMessage1 || displaySuccessMessage2 || nfnSuccessData">
    <div class="section outercontainer">
        <div id="login-confirmation-container" class="outer-container login-confirmation-container  ng-scope"
            cfet-just-in-time-confirmation="_">
            <div *ngIf="!displaySuccessMessage2" class="section columncontrol">
                <div class="row confirmation-column " id="confirmation-column">
                    <div class="col-md-3">
                    </div>
                    <div class="col-md-6 span6 span6-md span6-sm span6-xsm">
                        <div class="parbase section text">
                            <div id="success-image" class="success-image ">
                                <div id="success-icon-id" class="icon-controls-approvalL" role="img"></div>
                                <div class="complete-message">{{cfetLabels.activation_success.success}}</div>
                            </div>
                        </div>
                        <div class="parbase section text">
                            <div id="confirmation-message" class="confirmation-message " *ngIf="!showSubPaidUser">
                                <p *ngIf="nfnSuccessData;then nfnSuccess else defaultSuccess"></p>
                                <ng-template #nfnSuccess>
                                    <p
                                        *ngIf="nfnSuccessData.nfnMultipleSuccessMessage || nfnSuccessData.nfnSingleSuccessMessage;then nfnRegistrationSuccess else nfnTransferSuccess">
                                    </p>
                                    <ng-template #nfnRegistrationSuccess>
                                        {{(nfnSuccessData.nfnMultipleSuccessMessage) ? 
                                            cfetLabels.activation_success.nonfn_multiple_activation_success : 
                                            cfetLabels.activation_success.nonfn_single_activation_success.replace('[[SYSTEMID]]', nfnSuccessData.systemId)}}
                                    </ng-template>
                                    <ng-template #nfnTransferSuccess>
                                        {{cfetLabels.system_id_transfer.system_id_transfer_success}}
                                    </ng-template>
                                </ng-template>
                                <ng-template #defaultSuccess>
                                    {{cfetLabels.activation_success.registration_success}}
                                </ng-template>
                                <p *ngIf="nfnSuccessData">{{cfetLabels.activation_success.nonfn_activation_sub_text}}
                                </p>
                            </div>
                            <div id="confirmation-message" class="confirmation-message " *ngIf="showSubPaidUser">
                                {{cfetLabels.activation_success.show_sub_paid}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                    </div>
                </div>
            </div>
            <div *ngIf="displaySuccessMessage2">
                <app-page-title [pageTitle]="cfetLabels.activation_success.success"
                    [pageSubTitle]="cfetLabels.activation_success.sonim_success"></app-page-title>
            </div>
            <div class="dividercomp section">
                <div class="row">
                </div>
            </div>
            <div class="button section">
                <div *ngIf="!showSubPaidUser">
                    <div class="success-login-btn">
                        <div class="firstnet-btn" id="firstnet-btn"
                            *ngIf="nfnSuccessData;then nfnSuccessBtn else defaultBtn"></div>
                        <ng-template #nfnSuccessBtn>
                            <button class="btn btn-alt btn-medium">
                                {{cfetButtonLabels.button_labels.login}}
                            </button>
                        </ng-template>
                    </div>
                    <ng-template #defaultBtn>
                        <button class="btn btn-alt btn-medium" (click)="goToFirstnet()">
                            {{displaySuccessMessage2 ? cfetButtonLabels.button_labels.sonim_go_to_firstnet : cfetButtonLabels.button_labels.go_to_firstnet}}
                        </button>
                    </ng-template>
                </div>
                <div *ngIf="showSubPaidUser" class="success-login-btn">
                    <button class="btn btn-alt btn-medium">
                        {{cfetButtonLabels.button_labels.go_to_firstnet}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>